import angular from 'angular';

export default angular.module('shared').constant('usageTypeConstants', {
    platformUser: 'platformUser',
    device: 'device',
    storage: 'storage',
    bandwidth: 'bandwidth'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/usageType.constant.js